@if (type === PortalNotificationType.RELEASE_NOTES) {
  <portal-modal-header
    [title]="'notification.type.RELEASE_NOTES' | translate"
    (onClose)="dismiss()"
  ></portal-modal-header>
} @else {
  <portal-modal-header [title]="title()?.title" (onClose)="dismiss()"></portal-modal-header>
}

<portal-modal-body>
  <div class="d-flex flex-column gap-2">
    @if (titleImage() != null) {
      <img class="title-image" [src]="titleImage()" />
    }

    <portal-notification-live-view-item
      [showTitle]="false"
      [showTitleImage]="true"
      [translations]="currentTranslations()"
    />

    @if (publicationDate != null) {
      <footer class="text-muted pt-1">
        <small>
          {{ 'myNotifications.publishedAt' | translate: { date: publicationDate | portalTimeAgo } }}
        </small>
      </footer>
    }
  </div>
</portal-modal-body>

<portal-modal-footer [closeOnly]="true" (onCancel)="dismiss()"></portal-modal-footer>
